import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardHeader, CardBody } from 'reactstrap';


import Skeleton from 'react-loading-skeleton'
import generationIcon from "../../../assets/images/generation.png";
import genderIcon from "../../../assets/images/gender.png";
import earth from "../../../assets/images/earth.png";
import hand from "../../../assets/images/hand.png";
import Loader from '../../../components/common/Loader';

const TableRow = ({ iconSrc, label, value }) => (
    <tr>
        <td className="p-2">
            <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                    <img src={iconSrc} alt="" className="avatar-sm p-2" />
                </div>
                <div>
                    <h5 className="fs-14 my-1 fw-medium text-muted">
                        {label}
                    </h5>
                </div>
            </div>
        </td>
        <td>
            <h5 className="fs-14 mb-0 text-end">
                {value || <Skeleton />}
            </h5>
        </td>
    </tr>
);

const DemographicCard = ({ generation, gender, country, city, purchasingPower }) => {
    const demographicLoading = useSelector(state => state.demographic.loading);

    return (
        <Card
            className="card-height-100 d-flex align-items-center"
            style={{
                maxHeight: "418px",
                minHeight: "418px",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
                marginLeft: "10px",
            }}
        >
            <CardHeader className="align-items-center d-flex flex-grow-0">
                <h4 className="card-title mb-0 flex-grow-1 py-1">
                    <b>Demographic Segmentation</b>
                </h4>
            </CardHeader>

            {demographicLoading ?
                (<CardBody style={{
                    display: "flex",  
                    justifyContent: "center",  
                    alignItems: "center"  
                }} className="w-100 h-100">
                    <Loader/>
                </CardBody>
                ) :
                (
                    <CardBody className="w-100 h-100">
                        <div
                            className="table-card table-responsive d-flex align-items-center my-auto"
                            style={{ padding: "15px", paddingTop: "0px" }}
                        >
                            <table className="table align-middle m-0 h-100">
                                <tbody>
                                    <TableRow
                                        iconSrc={generationIcon}
                                        label="Generation"
                                        value={generation}
                                    />
                                    <TableRow
                                        iconSrc={genderIcon}
                                        label="Gender"
                                        value={gender}
                                    />
                                    <TableRow
                                        iconSrc={earth}
                                        label="Country / City"
                                        value={`${country} / ${city}`}
                                    />
                                    <TableRow
                                        iconSrc={hand}
                                        label="Purchasing Power"
                                        value={purchasingPower}
                                    />
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                )
            }
        </Card>
    );
};

export default DemographicCard;